<template>
  <div class="cf-container">
    <div 
      v-if="showAvailableNodes"
      class="cf-available-nodes"
    >
      <template v-for="(node, index) in nodesAvailableToAdd">
        <button
          v-if="node.isPopular"
          :key="index"
          class="cf-available-nodes__button"
          @click="validateNode(node)"
        >
          {{ node.displayName }}
        </button>
      </template>

      <Dropdown
        ref="dropdown"
        tag="span"
        :menu-left="true"
      >
        <button class="cf-available-nodes__button cf-available-nodes__button--secondary">
          More <i
            class="fa fa-angle-down p-l-10"
            aria-hidden="true"
          />
        </button>

        <template slot="dropdown">
          <template v-for="(node, index) in nodesAvailableToAdd">
            <li
              v-if="!node.isPopular"
              :key="index"
              @click="validateNode(node)"
            >
              {{ node.displayName }}
            </li>
          </template>
        </template>
      </Dropdown>
      <Loader
        v-if="isValidatingNode"
        custom-class="size-sm"
      />
    </div>
    <CallFlowContainer
      ref="callFlowContainer" 
      :available-nodes="availableNodesWithStyling"
      @drawNode="validateNode"
    />
  </div>
</template>

<script>
import { merge } from 'lodash';
import messages from '../../locales';
import { utilities, $ngStateService } from '@/angularBridgeCode/ringbaPortal.servicesModule';
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';

import { emptyCallFlow } from '../../helpers/constants';

import CallFlowContainer from './CallFlowContainer';
import Loader from '@/core/components/Loader';
import { STATUS_SUCCESS, STATUS_PENDING } from '@/store/helpers';
import cloneDeep from 'lodash/cloneDeep';

export default {
  name: 'CallFlowView',
  components: {
    CallFlowContainer,
    Loader,
  },
  props: {
    scene: {
      type: Object,
      default() { 
        return { 
          name: '', 
          nodes: [], 
          links: [], 
          container: {} 
        }; 
      },
    }
  },

  computed: {
    ...mapState('callFlows', [
      'sceneErrors',
      'availableNodes'
    ]),

    ...mapState('callFlows', {
      selectedNode: state => state.scene.selectedNode
    }),

    ...mapGetters('callFlows', [
      'getAvailableNodesStatus',
      'availableNodesWithStyling',
      'getAvailableNodesStatus',
      'getAttachNodeStatus'
    ]),

    isValidatingNode() {
      return this.getAttachNodeStatus.status == STATUS_PENDING;
    },
    
    showAvailableNodes() {
      return this.getAvailableNodesStatus.status == STATUS_SUCCESS;
    },

    nodesAvailableToAdd() {
      return this.availableNodesWithStyling.filter(n => n.id !== 'root').sort((a,b) => a.displayName.localeCompare(b.displayName));
    },
  },
  methods: {
    ...mapActions('callFlows', [
      'attachNode',
      'processSceneErrors',
      'addNode',
    ]),

    ...mapMutations('callFlows', [
      'deselectNode'
    ]),

    async validateNode(newNode, { originNode, slotNumber, isOnFailure, criteria, targetSlotNumber, filter } = {}, unselectNode = true) {
      const node = cloneDeep(newNode);

      node.nodeErrors = [];
      node.isValid = true;

      node.settings = node.settings ? node.settings : {};

      const payload = {
        node: node, 
        tree: emptyCallFlow,
        parentNodeId: 'root',
        criteria: [],
        onSuccess: false
      };

      try {
        const res = await this.attachNode(payload);
        node.id = Object.keys(res.ivrTree.nodes)[0];
        this.drawNode(node, { originNode, slotNumber, isOnFailure, targetSlotNumber, criteria, filter }, unselectNode);
      } catch(e) {
        console.error(e);
        if (e.status === 400 && e.data !== null && e.data.nodeErrors !== null) {
          node.nodeErrors = merge({}, ...e.data.nodeErrors);
          node.isValid = false;
          node.id = Object.keys(e.data.ivrTree.nodes)[0];
          delete node.nodeErrors.nodeId;
          this.drawNode(node, { originNode, slotNumber, isOnFailure, targetSlotNumber, criteria, filter }, unselectNode);
          this.processSceneErrors(e.data.errors);
        } else {
          utilities.showToaster('error', this.$i18n.t('ATTACH_NODE_ERROR_MESSAGE'));
        }
      }
    },
    drawNode(node, { originNode, slotNumber, isOnFailure, criteria, targetSlotNumber, filter} = {}, unselectNode = true) {
      if (this.selectedNode && unselectNode) {
        this.deselectNode(this.selectedNode.id);
      }

      this.addNode({
        node,
        originNode, 
        slotNumber, 
        isOnFailure, 
        criteria,
        targetSlotNumber,
        filter
      });
    },

    showAllCallFlows() {
      $ngStateService.go('dashboard.call-flows');
    },
  },
  i18n: {
    messages,
    locale: 'en',
  },
};
</script>